export default __webpack_public_path__ + "static/women4-c740c1e5db329d2053d4569df4a4abee.webp";